import { useEffect, useState } from 'react';

import { IRequestFilters } from 'coreOld/types';
import { getListPayload } from 'coreOld/utils';
import { useGetPart } from 'partsOld/hooks';
import { IPartAutocomplete } from 'partsOld/types';

import AddCompanyPartView from './AddCompanyPartView';

interface IProps {
  filter: Record<string, any>;
}

const AddCompanyPart = ({ filter }: IProps) => {
  const [value, setValue] = useState<IPartAutocomplete>(null);
  const [filters, setFilters] = useState<IRequestFilters>(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const { record, refetch, isLoading } = useGetPart(getListPayload(filters), Boolean(value));

  const onAddPart = () => {
    setFilters({
      query: value?.number,
    });

    setIsPanelOpen(true);
  };

  useEffect(() => {
    if (value) {
      refetch();
    }
  }, [filters]);

  const onClosePanel = () => {
    setIsPanelOpen(false);
    setValue(null);
  };

  return (
    <AddCompanyPartView
      filter={filter}
      value={value}
      setValue={setValue}
      isPanelOpen={isPanelOpen}
      onClosePanel={onClosePanel}
      onAddPart={onAddPart}
      part={record?.[0] || value}
      isLoading={isLoading}
    />
  );
};

export default AddCompanyPart;
